import React from "react";
import { ReactComponent as Pending } from "../icons/pending.svg";
import { ReactComponent as Cooking } from "../icons/cooking.svg";
import { ReactComponent as Ready } from "../icons/serve.svg";
import { ReactComponent as Delivered } from "../icons/delivered.svg";
import { ReactComponent as Canceled } from "../icons/canceled.svg";

const iconOrderComponents = [
  <Pending />,
  <Cooking />,
  <Ready />,
  <Delivered />,
  <Canceled />,
];
export default iconOrderComponents;
